import imgInjection from '../assets/images/Injection-molding-machine.png';
import imgBeverage from '../assets/images/Pet-beverage-filling-line.png';
import imgPreform from '../assets/images/pet-preforn-mold.png';
import imgLab from '../assets/images/PET-material-lab-equipment.jpg';
import imgPackagingSystems from '../assets/images/Packaging&Systems.jpg';
import imgIntegratedPlastic from '../assets/images/integratedplastic.jpg';
import imgCaps from '../assets/images/caps-closures-mold.jpg';
// packaging-mold.jpg not present; use Packaging&Systems.jpg instead
import imgPackaging from '../assets/images/Medical-pharma-paxkaging-mold.jpg';
import imgHTW from '../assets/images/htw-cartridge-mold.jpg';
import imgIntravis from '../assets/images/intravis-capwatcher-qline.jpg';

const productsData = [
  {
    id: 1,
    title: "Injection Molding Machine",
    slug: "injection-molding",
    description: "Precision injection molding equipment for plastic product manufacturing.",
    features: [
      "High-precision components",
      "Servo-hydraulic technology",
      "Customizable injection profiles",
      "Automated part removal",
      "Industry 4.0 compatibility"
    ],
    specifications: "Clamping force: 50-1000 tons\nInjection capacity: 30-5000g\nControl system: Advanced PLC with touchscreen interface",
    industryId: 3,
    images: [
      {
        url: imgInjection,
        isPrimary: true,
        displayOrder: 1
      }
    ],
    displayOrder: 1
  },
  {
    id: 2,
    title: "Beverage Filling Line",
    slug: "beverage-filling",
    description: "Complete beverage filling systems for efficient bottling operations.",
    features: [
      "High-speed filling performance",
      "Accurate volumetric control",
      "Flexible container handling",
      "Integrated capping and labeling",
      "Hygienic design for food safety"
    ],
    specifications: "Filling speed: up to 36,000 bottles/hour\nContainer types: bottles, jars, cans\nControl: PLC with touchscreen interface",
    industryId: 2,
    images: [
      {
        url: imgBeverage,
        isPrimary: true,
        displayOrder: 1
      }
    ],
    displayOrder: 2
  },
  {
    id: 3,
    title: "PET Preform Molds",
    slug: "pet-preform",
    description: "Precision-engineered molds for PET preform production.",
    features: [
      "High durability molds",
      "Optimized cooling channels",
      "Precision tolerances for consistent weight",
      "Easy maintenance and serviceability",
      "Compatible with major preform machines"
    ],
    specifications: "Cavity count: 2-32 cavities\nMaterial: high-grade tool steel\nSuitable for PET preforms from 200ml to 2L",
    industryId: 1,
    images: [
      {
        url: imgPreform,
        isPrimary: true,
        displayOrder: 1
      }
    ],
    displayOrder: 3
  },
  {
    id: 4,
    title: "Lab Equipment",
    slug: "lab-equipment",
    description: "Specialized laboratory equipment for material testing and quality control.",
    features: [
      "Comprehensive material testing capabilities",
      "Precision measurement instruments",
      "Laboratory-grade control systems",
      "Ergonomic and safe operation",
      "Calibration and validation support"
    ],
    specifications: "Equipment range: viscometers, spectrometers, material testers\nSupports quality control for plastics, containers, and caps",
    industryId: 4,
    images: [
      {
        url: imgLab,
        isPrimary: true,
        displayOrder: 1
      }
    ],
    displayOrder: 4
  },
  {
    id: 5,
    title: "Exclusive Applications",
    slug: "integrated-plastics",
    description: "Integrated plastic container solutions for market-ready product applications.",
    features: [
      "Patented lightweight container designs",
      "High-quality barrier properties",
      "Customizable shapes and finishes",
      "Sustainable recyclable materials",
      "Rapid development support"
    ],
    specifications: "Applications: food packaging, industrial containers, specialty bottles\nCustom designs available for volume production",
    industryId: 2,
    images: [
      {
        url: imgIntegratedPlastic,
        isPrimary: true,
        displayOrder: 1
      }
    ],
    displayOrder: 5
  },
  {
    id: 6,
    title: "Caps & Closures Mold",
    slug: "caps-mold",
    description: "Specialized molds for producing high-quality caps and closures.",
    features: [
      "Precision cavity design",
      "Fast cycle times",
      "Wear-resistant tool steel",
      "Consistent cap geometry",
      "Optimized ejection systems"
    ],
    specifications: "Cavity options: up to 48 cavities\nSuitable for caps and closures in multiple sizes and styles",
    industryId: 3,
    images: [
      {
        url: imgCaps,
        isPrimary: true,
        displayOrder: 1
      }
    ],
    displayOrder: 6
  },
  {
    id: 7,
    title: "Packaging Mold",
    slug: "packaging-mold",
    description: "Precision manufacturing molds for diverse packaging applications.",
    features: [
      "High dimensional accuracy",
      "Optimized cooling performance",
      "Durable mold construction",
      "Low wear and maintenance",
      "Suitable for complex packaging designs"
    ],
    specifications: "Mold material: hardened tool steel\nProduction capacity: designed for high-volume packaging lines",
    industryId: 3,
    images: [
      {
        url: imgPackaging,
        isPrimary: true,
        displayOrder: 1
      }
    ],
    displayOrder: 7
  },
  {
    id: 8,
    title: "Packaging & Systems",
    slug: "packaging-systems",
    description: "Advanced packaging systems for end-to-end product handling and finishing.",
    features: [
      "Automated packaging workflows",
      "Modular system design",
      "High-speed performance",
      "Integrated inspection and labeling",
      "Flexible format changeovers"
    ],
    specifications: "System speed: up to 120 packages per minute\nCompatible with bottles, jars, pouches, and cartons",
    industryId: 2,
    images: [
      {
        url: imgPackagingSystems,
        isPrimary: true,
        displayOrder: 1
      }
    ],
    displayOrder: 8
  },
  {
    id: 9,
    title: "Cartridge Moulds",
    slug: "htw",
    description: "High-precision cartridge moulds for silicon and grease cartridges.",
    features: [
      "Silicon cartridge moulds with 2-16 cavities",
      "Grease cartridge moulds with 2-8 cavities",
      "Valve-gate system for better filling quality",
      "Fast cycle times for efficient production"
    ],
    specifications: "Silicon cartridges: cycle time 10-12 seconds\nGrease cartridges: cycle time 12-14 seconds\nValve-gate system for superior quality",
    industryId: 3,
    images: [
      {
        url: imgHTW,
        isPrimary: true,
        displayOrder: 1
      }
    ],
    displayOrder: 9
  },
  {
    id: 10,
    title: "Inspection Systems",
    slug: "intravis",
    description: "Turnkey vision inspection systems for preforms, closures, bottles and decoration.",
    features: [
      "Preform inspection with inline and offline systems",
      "360-degree closure inspection",
      "Bottle and container quality assurance",
      "Customizable inspection solutions for packaging"
    ],
    specifications: "Systems for preforms, caps, bottles, decoration and barrier layers\nHigh-speed inspection and defect prevention",
    industryId: 4,
    images: [
      {
        url: imgIntravis,
        isPrimary: true,
        displayOrder: 1
      }
    ],
    displayOrder: 10
  },
];

export default productsData;
  